var map = {
	"./007-microphone-1.png": 1331,
	"./010-home.png": 65449,
	"./013-document-1.png": 94678,
	"./014-document.png": 34690,
	"./015-color-palette.png": 47228,
	"./017-video-camera.png": 85817,
	"./024-like.svg": 28038,
	"./1.svg": 83169,
	"./155-credit-card.svg": 58534,
	"./2.svg": 214,
	"./3.svg": 44122,
	"./4.svg": 27103,
	"./New Customer.svg": 68114,
	"./NotOpen.svg": 18012,
	"./Opened.svg": 13732,
	"./Profit.svg": 96755,
	"./SalesRevenue.svg": 18079,
	"./Sent.svg": 84477,
	"./Slack.svg": 7790,
	"./address.svg": 20633,
	"./adidas.svg": 35879,
	"./adobe.svg": 55253,
	"./arrow-growth.svg": 46097,
	"./arrow-left.png": 41755,
	"./arrow-left.svg": 47156,
	"./arrow-right.png": 55831,
	"./arrow-right.svg": 84908,
	"./bell.svg": 86316,
	"./book-open.svg": 13571,
	"./book.svg": 45183,
	"./box.svg": 90410,
	"./box2.png": 51320,
	"./briefcase.svg": 20325,
	"./camera.svg": 18906,
	"./chat.svg": 5971,
	"./check-circle.svg": 23717,
	"./clipboard.svg": 78178,
	"./clock.svg": 54152,
	"./cloud.svg": 3288,
	"./columns.svg": 90718,
	"./delivery-c.svg": 29430,
	"./delivery.svg": 15940,
	"./documentation.svg": 92815,
	"./dollar-circle.svg": 36985,
	"./envelope.svg": 32128,
	"./file.svg": 26439,
	"./flat.svg": 13653,
	"./google-customIcon.svg": 8848,
	"./google-plus.svg": 30381,
	"./headphone.svg": 7924,
	"./heart-fill.svg": 78946,
	"./home.svg": 53002,
	"./iconfinder_trello_2317760.svg": 10180,
	"./idea.svg": 1926,
	"./image.png": 38420,
	"./image.svg": 96324,
	"./label.png": 36887,
	"./layers.svg": 91300,
	"./left-bar.svg": 13938,
	"./left.svg": 71714,
	"./logo2.svg": 75709,
	"./logo3.svg": 44142,
	"./logo4.svg": 41251,
	"./logo5.svg": 57586,
	"./logo6.svg": 81832,
	"./logoIn.svg": 75569,
	"./message.svg": 6613,
	"./microsoft.svg": 46332,
	"./money-wave.svg": 45011,
	"./paint.svg": 32179,
	"./process.svg": 94070,
	"./protection.svg": 77280,
	"./quote-left.png": 63140,
	"./quote-right.png": 40825,
	"./quote.png": 220,
	"./refresh.svg": 98206,
	"./repeat.svg": 6294,
	"./right.svg": 39961,
	"./setting.svg": 97849,
	"./shopping-cart.svg": 80466,
	"./speed-meter.svg": 57546,
	"./strategy.svg": 91096,
	"./theme.svg": 44530,
	"./ticket.svg": 29734,
	"./truck.svg": 7236,
	"./user.svg": 55521,
	"./users-alt.svg": 40142,
	"./water-fall.svg": 54725,
	"./wordpress.svg": 32877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34542;